<template>
    <div class="wrapper">
        <div class="text">Components</div>
        <div class="table__list">
            <div class="item" v-for="item in array" v-if="array.length > 0">
                <div class="title">{{item.title}}</div>
                <div class="specifications" v-if="item.specifications" v-for="items in item.specifications">
                    <div class="name">{{items.name}}:</div>
                    <div class="value">{{items.value}}</div>
                </div>
                
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            array: [Array, Object],
        },
    }
</script>

<style scoped>
.wrapper{
    padding-top: 88px;
}
.wrapper .text{
    padding-bottom: 26px;
}
.table__list{
    display: flex;
    flex-wrap: wrap;
    row-gap: 51px;
    column-gap: 16px;
    /* Tabs/T1: 13px Medium */
    color: rgb(85, 98, 114);
    font-size: 13px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
    text-align: left;
}
.item{
    display: flex;
    flex-direction: column;
    padding: 10px;
    width: calc((100% / 4) - 14px);
    border: 1px solid rgb(222, 230, 234);
    border-radius: 8px;
}
.item .specifications{
    display: flex;
    gap: 6px;
    align-items: center;
}
.item .specifications .name{
    font-size: 14px;
    color: #4C4C4C;
}
.item .specifications .value{
/* Header/H3: 24px Medium */
color: rgb(5, 5, 5);
font-size: 14px;
font-weight: 500;
line-height: 140%;
letter-spacing: 0%;
text-align: left;
}
.item .title{
/* Header/H4: 16px Medium */
color: #030304;
font-size: 24px;
font-weight: 500;
line-height: 140%;
letter-spacing: 0%;
text-align: left;
}

@media (max-width: 1024px) {
    .item .value{
        font-size: 20px;
    }
    .item{
        width: calc((100% / 3) - 11px);
    }
}
@media (max-width: 768px) {
    .table__list{
        flex-direction: column;
    }
    .item{
        width: 100%;
    }
    .item .value{
        font-size: 16px;
    }
}
</style>